<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2020-03-02 20:19:15
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-03-08 18:43:16
 * @Description: file content
 -->
<template>
  <div class="t9_zxrc">
    <div class="section_projects">
      <div
        v-for="(project,projectIndex) in projectList"
        v-if="project.extinfo&&project.extinfo.buildingBanner"
      >
        <div class="projects" @click="tapProject(project)">
          <div class="projects_name">{{project.extinfo.buildingName}}</div>
          <div class="op">
            <img src="https://assets.rurushishi.com//yq-rs-make/t9_zxrg/arrow_2.png" alt />
          </div>
        </div>
      </div>
    </div>
    <!-- lj25 -->
    <BtnBackLayout4></BtnBackLayout4>
  </div>
</template>

<script>
import util from "@/utils/utils";
import { mapState, mapMutations } from "vuex";
import * as comreq from "@/utils/comreq";
import Cookies from "js-cookie";
const BtnBackLayout4 = () => import("@/components/btn_back_layout4");
export default {
  components: {
    BtnBackLayout4
  },
  props: {},
  data() {
    return {
      projectList: []
    };
  },
  watch: {},
  computed: {
    ...mapState([
      "isShowGuide",
      "isInMiniProgram",
      "receiveSpreadInfo",
      "shareSpreadInfo",
      "pageInfo",
      "userInfo"
    ])
  },
  methods: {
    tapProject(item) {
      let initObj = Cookies.get("t9_20200131_init");
      if (initObj) {
        initObj = JSON.parse(initObj);
      }
      let url = `${location.protocol}//${location.host}/marketies/onlinerecognition/${this.$route.query.page}?entry=zxslzx&t9id=${initObj.id}&t9psn=${initObj.psn}`;
      if (this.global.isLoc) {
        url = `http://localhost:2001/marketies/onlinerecognition/${this.$route.query.page}?entry=zxslzx&t9id=${initObj.id}&t9psn=${initObj.psn}`;
      }
      // 如果有传播者也一并把传播者传到打开的页面
      if (this.receiveSpreadInfo.refereeopenid) {
        url += `&refereeopenid=${this.receiveSpreadInfo.refereeopenid}`;
      }
      if (this.receiveSpreadInfo.rscuid) {
        url += `&rscuid=${this.receiveSpreadInfo.rscuid}`;
      }
      url += `&pid=${item.extinfo.houseOnlineConfig.projectId}`;
      if (util.getIsAcglr(this.userInfo)) {
        url += `&managerId=1`;
      }
      util.openUrl(url);
    }
  },
  created() {
    util.checkMapStateCallback(this, ["pageInfo"]).then(() => {
      if (this.pageInfo.Extinfo.content_pagetags) {
        let pagetagsObj = {
          // channel: null,
          // banner: null,
          // 热点新闻: null,
          // 精选项目: null
        };
        pagetagsObj.channel = {
          pagetags: this.pageInfo.Extinfo.content_channel_tags,
          tagname: this.pageInfo.Extinfo.content_channel_tags_name
        };
        this.pageInfo.Extinfo.content_pagetags.forEach(item => {
          pagetagsObj[item.section] = item;
        });
        comreq
          .listPageInfoWithChannel2(
            pagetagsObj.channel.pagetags,
            pagetagsObj["精选项目"].pagetags
          )
          .then(data => {
            if (data && data.list) {
              data.list = data.list.map(item => {
                if (item.extinfo) {
                  item.extinfo = JSON.parse(item.extinfo);
                  if (item.extinfo.advantage) {
                    item.extinfo.advantage = item.extinfo.advantage.split(",");
                  }
                }
                return item;
              });
              data.list = data.list.filter(item => {
                if (item.extinfo.houseOnlineConfig) {
                  console.log(
                    "item.extinfo.houseOnlineConfig",
                    item.extinfo.buildingName,
                    item.extinfo.houseOnlineConfig
                  );
                  return true;
                }
                return false;
              });
              this.projectList = data.list;
            }
            console.log("精选项目", JSON.parse(JSON.stringify(data)));
          });
      }
    });
  },
  mounted() {}
};
</script>
<style lang="css" scoped>
/* 精选项目 */
.section_projects {
  width: 100%;
  padding-bottom: 20px;
}

.projects {
  width: 90%;
  padding: 20px 0;
  margin-left: 5%;
  border-bottom: 1px solid #f7f7f7;
  display: flex;
  justify-content: space-between;
}
.projects .op img {
  width: 20px;
  height: 20px;
}
</style>